import { ToastState, Toast } from './types'

export const getToasts = ({ toasts }: Pick<ToastState, 'toasts'>): Toast[] => {
  return toasts
}
